module.exports = __webpack_public_path__ + "static/media/Weedle_gaussian2.6feadf32.png";